import classnames from 'classnames';
import { Icon } from 'components/common';

interface HeroBacklinkProps {
  goBack: () => void;
  name: string;
  outline?: boolean;
  testId?: string;
}

const HeroBacklink = ({ goBack, name, outline = false, testId = '' }: HeroBacklinkProps) => (
  <button
    className={classnames('btn fw-bold', outline ? 'btn-outline-primary' : 'btn-primary-dark')}
    data-testid={testId}
    onClick={goBack}
    type="button"
  >
    <Icon name="chevron-left" />
    {' Back to '}
    {name}
  </button>
);

export default HeroBacklink;
